<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <!-- <el-button class="title_btn" type="primary" size="" @click="addBtn()">등록</el-button> -->
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <div class="table_search">
              <el-row>
                <el-col :span="12">
                  <span class="t_s_title">검색</span>
                  <el-select v-model="tableSelected" placeholder="Select" class="table_s_select">
                    <el-option v-for="item in tableSelectOption" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="table_s_input" v-model="tableSearch" size="" placeholder="검색어를 입력해주세요."
                    @keyup.enter.native="[getList(), page = 1]" />

                </el-col>
                <el-col :span="12">
                  <span class="t_s_title">회원상태</span>
                  <span class="el-checkbox-group">
                    <el-radio-group v-model="filterType">
                      <el-radio :label="''">전체</el-radio>
                      <el-radio :label="1">일반</el-radio>
                      <el-radio :label="2">블랙</el-radio>
                    </el-radio-group>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="search_btn_wrap text_center">
              <el-button type="primary" @click="[getList(), page = 1]">검색</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" empty-text="데이터가 없습니다." v-loading="tableLoading">
              <el-table-column class="table_no" type="index" label="번호" width="100" class-name="num" :index="tableIndex">
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop" :label=header.label :prop=header.prop
                :width=header.width :class-name=header.class></el-table-column>
              <el-table-column v-if="tableoption" align="center" width="100" label="옵션">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <!-- <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="lastPage > 0">
            <el-pagination :page-size=filterPagnation.size :pager-count=filterPagnation.pagerCount
              layout="prev, pager, next" :current-page.sync=page :total="listTotal" @current-change="getList">
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
import VuxAlert from '@/mixins/vux-alert';
import sessionStorage from '@/mixins/sessionStorage';
import localStorage from '@/mixins/localStorage'
import util from '@/mixins/util'
import { countryList } from "@/service/countryService";

export default {
  name: "Member",
  components: {},
  mixins: [VuxAlert, sessionStorage, localStorage],
  data() {
    return {
      userInfo: this.getUserInfo(),
      tableLoading: true,
      data: {},
      title: this.$route.meta.title,
      tableData: [],
      tableSearch: '',
      tableHeader: [
        /* {
          label: '아이디',
          prop: 'Member.mb_id',
          class: 'text_center'
        }, */
        // {
        //   label: '이름',
        //   prop: 'Member.mb_name',
        //   class: 'text_center'
        // },

        {
          label: '휴대폰번호',
          prop: 'Member.mb_hp',
          class: 'text_center'
        }, {
          label: '회원타입',
          prop: 'Member.mb_type_name',
          class: 'text_center'
        }, {
          label: '가입일',
          prop: 'Member.created_at',
          class: 'text_center'
        }
      ],
      tableoption: true,
      pagnation: {
        size: 10,
        pagerCount: 11,
        page: 1,
      },
      page: 1,
      lastPage: 0,
      listTotal: 0,
      tableSelected: 'na',
      tableSelectOption: [
        {
          label: '이름',
          value: 'na'
        },
        {
          label: '휴대폰번호',
          value: 'hp'
        }
      ],
      filterType: '',
      category: [],
      c_idx: 1,
    }
  },

  created() {
    /*if(this.$sessionStorage.get('first')){
      this.$sessionStorage.set('first' , false);
      location.reload();
    }*/
  },
  computed: {
    tableFilter() {
      return this.tableData
    },
    filterPagnation() {
      return {
        size: 10,
        pagerCount: 11,
        total: this.tableFilter.length,
        page: 1
      }
    }
  },
  mounted() {
    this.getCountryList();
    this.getList();
  },

  beforeRouteLeave(to, from, next) {
    if (to.path === "/auth" && this.$route.query.first) {
      next(false);
    } else {
      return next();
    }
  },

  methods: {
    addBtn() {
      this.$router.push('/method/detail');
    },

    resetPage() {
      this.page = 1
    },
    getCountryList() {
      this.$api.$user.getCountry()
        .then(res => {
          this.category = countryList;
        });
    },
    async getList() {
      this.tableLoading = true;
      let params = {
        page: this.page,
        g_idx: 1,
        m_type: 'normal',
        ip: 1,
        c_idx: this.c_idx,
      }

      if (this.tableSearch != '') {
        params[this.tableSelected] = this.tableSearch
      }
      if (this.filterType != '') {
        params.ty = this.filterType
      }
      await this.$api.$user.getMemberList(params).then(res => res.Data.Result).then(res => {
        if (res.Info.Type === 1) {
          this.tableData = res.List;
          this.lastPage = res.Page.last_page;
          this.listTotal = res.Page.total;

          util.each(this.tableData, (item, index, allItems) => {
            item.Member.mb_type_name = item.Member.mb_type === 1 ? '일반회원' : '블랙회원';

          });
        } else {
          this.tableData = [];
          this.page = 1;
          this.lastPage = 0;
          this.listTotal = 0;
        }

        // this.tableSelected = this.tableSelectOption[0].value;
        this.tableLoading = false;
      })
    },

    handleEdit(index, row) {
      this.$router.push('/member/detail/' + row.Member.mb_no);
    },

    handleDelete(index, row) {
      let alertParams = { 'element': this, 'key': row.v_idx };
      this.listDeleteAlert(alertParams);

    },

    selectChange() {
      //this.tableSearch = "";
    },

    tableIndex(index) {
      return index + this.pagnation.size * (this.page - 1) + 1
    },
  }
}

</script>
